import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Analytics } from "@vercel/analytics/react";

const GOOGLE_CLIENT_ID = "920633833640-qtr9d0d0ns21f2gg84dku9mfb5mv4nif.apps.googleusercontent.com";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <Analytics />
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>,
);
